import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { UploadedFileData } from '../../domain/uploaded-file';
import * as FileUploadActions from '../file-upload.actions';
import { AppState } from '../file-upload.reducer';
import { selectCxbUploadedFileByClientId } from '../file-upload.selectors';
import { UploadedFileViewModel } from './file-upload.view-model';
import { RemoveFileConfirmationDialogComponent } from './remove-file-confirmation-dialog/remove-file-confirmation-dialog.component';

@Injectable()
export class FileUploadService {
  constructor(private readonly store: Store<AppState>, private readonly dialogService: MatDialog) {}

  public uploadFile$(file: File): Observable<UploadedFileViewModel> {
    const clientId = uuidv4();
    this.store.dispatch(FileUploadActions.uploadCxBFile({ file, clientId }));
    return this.store.pipe(
      select(selectCxbUploadedFileByClientId(clientId)),
      map((fileData: UploadedFileData | undefined) => {
        if (!fileData) {
          return undefined;
        }
        return this.mapDomainUploadedFileDataToViewModel(fileData);
      })
    );
  }

  public async deleteFile(fileId: string, isFileRequired: boolean, warningText?: string) {
    let deleteConfirmed = true;

    if (isFileRequired) {
      deleteConfirmed = await firstValueFrom(
        this.dialogService.open(RemoveFileConfirmationDialogComponent, { data: warningText }).afterClosed()
      );
    }

    if (deleteConfirmed) {
      this.store.dispatch(FileUploadActions.deleteCxBFile({ fileId }));
    }
    return deleteConfirmed;
  }

  public async hideFile(isFileRequired: boolean, warningText?: string) {
    let deleteConfirmed = true;

    if (isFileRequired) {
      deleteConfirmed = await firstValueFrom(
        this.dialogService.open(RemoveFileConfirmationDialogComponent, { data: warningText }).afterClosed()
      );
    }

    return deleteConfirmed;
  }

  private mapDomainUploadedFileDataToViewModel(fileData: UploadedFileData): UploadedFileViewModel {
    return {
      id: fileData.id,
      name: fileData.name,
      publicUrl: fileData.publicUrl,
    };
  }
}
